import { lsStore, persist } from '@/views/sports/components/bet-slip/check-bets';

export const CALCULATOR = 'CALCULATOR';

export const persistCalc = arr => persist(CALCULATOR, arr);
export const calcStore = () => lsStore(CALCULATOR);
